<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>知识百科</el-breadcrumb-item>
                    <el-breadcrumb-item>百科管理</el-breadcrumb-item>
                </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="6">
                    <div>
                        <el-aside>
                            <el-input style="margin-bottom:12px;" size="small"   placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            <el-tree class="filter-tree" :data="data" :props="defaultProps"  :filter-node-method="filterNode" @node-click="handleNodeClick" ref="tree"></el-tree>
                        </el-aside>
                    </div>
                </el-col>
                <el-col :span="18" :class="isShow?'show':'hidden'">
                    <el-row>
                        <el-col :span="4">
                            <el-input size="small" v-model="title" placeholder="请输入标题">
                                <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
                            </el-input>
                        </el-col>
                        <el-col :span="2">
                            <!-- <el-button size="small" @click="addWikiShadow">添加百科</el-button> -->
                        </el-col>
                        <el-col :span="18">
                            <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="pageSizes"
                            :page-size="pagesize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount"
                            style="float:right"
                            ></el-pagination>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                        <el-table :data="tableData" style="width: 100%" v-loading="loading" size="small">
                            <el-table-column prop="KnowledgeTitle" label="标题"></el-table-column>
                            <el-table-column prop="KnowledgeNodeName" label="节点"></el-table-column>
                            <el-table-column prop="AddUserName" label="发布人"></el-table-column>
                            <el-table-column prop="AddTime" label="发布时间"></el-table-column>
                            <el-table-column prop="LastEditTime" label="最后修改时间"></el-table-column>
                            <!-- <el-table-column :label="send?'百科状态':(edit?'百科状态':'')">{{cope.row.AuditStatus==1?'审核中':(scope.row.AuditStatus==2?'审核通过':(scope.row.AuditStatus==2?'审核退回':'编辑中'))}} </el-table-column> -->
                            <el-table-column label="删除"><template slot-scope="scope">{{scope.row.IsDelete==0?'否':'是'}}</template></el-table-column>
                            <el-table-column prop="DeleteTime" label="删除时间"></el-table-column>
                            <el-table-column label="操作" fixed="right" :span="8">
                                <template  slot-scope="scope" >
                                    <div>
                                        <el-button type="text" @click='bindWiki(scope.row)'>查看</el-button>
                                        <!-- <el-button type="text" @click='editWiki(scope.row)'>编辑</el-button> -->
                                        <el-button type="text" @click='lookShadow(scope.row)'>修改记录</el-button>
                                        <!-- <el-button type="text" @click='restoreWiki(scope.row)'>恢复</el-button> -->
                                        <!-- <el-button type="text" @click='moveWiki(scope.row)'>移动节点</el-button> -->
                                        <!-- <el-button type="text" style="color:red;" @click='delWiki(scope.row)'>删除</el-button> -->
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-card>
    </div>
    
</template>

<script>
  import { GetWikiNode,GetKnowledgePage,GetChildrenNodesId  } from "../../until/ZeusApiSDK/Logic/WikiLogic";
  export default {
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    created() {
        this.getWikiNode();
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //获取树状结构列表
      getWikiNode:async function(){
        await GetWikiNode().then(res => {
          this.data=JSON.parse(res);
        });
      },
      //节点点击事件
      handleNodeClick(data){
          this.isShow=true;
          this.nodeId=data.id;
          //获取数据
          this.getWikiList();
        },
        //选择每页条数
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pagesize = val;
            //重新获取列表数据
            this.getWikiList();
        },
        //跳转到第几页页面
        handleCurrentChange(val) {
            this.currentPage = val;
            //重新获取列表数据
            this.getWikiList();
        },
        getWikiList:function(){
            //获取所有子节点主键id 用逗号隔开
            GetChildrenNodesId(this.nodeId).then(res=>{
                var ids=res.toString();
                this.predicates=[
                {
                    Field:"KnowledgeNodeID", 
                    Value:ids, 
                    Oper:"in", 
                    IsAnd:1
                }];

                // //如果不是管理员显示本人发送
                if(this.title!=null&&this.title!=''){
                    this.predicates.push({Field:"KnowledgeTitle", Value:this.title, Oper:"contain", IsAnd:1 });
                } 
                GetKnowledgePage(this.predicates,this.currentPage,this.pagesize,'AddTime','desc').then(res=>{
                    this.loading=false;
                    this.totalCount=res.TotalCount;
                    this.tableData=res.DataList;
                });
            });
        },
        //添加条件搜索
        SearchByName:function(){
            this.getWikiList();
        },
        //查看百科详情
        bindWiki:function(data){
            //跳转到查看详情页面
            this.$router.push('/wiki/BindWiki?id='+data.KnowledgeID+'&name=百科管理');
        },
        //查看修改记录
        lookShadow:function(data){
            //跳转到对比公告页面
            this.$router.push('/wiki/EditRecord?id='+data.KnowledgeID+'&name='+data.KnowledgeTitle+'&title=百科管理');
        },
        //恢复
        // restoreWiki:function(data){
        // },
        // //删除
        // delWiki:function(data){

        // }
    },

    data() {
      return {
        totalCount:0,//默认数据总数
        pagesize:20,//每页的数据条数
        currentPage:1,//默认开始页面
        pageSizes:[1,10, 20, 50, 100, 200],//可选数据
        tableData: [],
        predicates:[],//参数
        nodeId:'',//节点id
        loading:true,
        wiki:{},
        content:'',
        title:'',
        filterText: '',
        isShow:false,
        data:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      };
    }
  };
</script>
<style lang="less" scoped>
.darkTag{
    margin-left: 10px;
    margin-right: 3px;
}
.show{
    display: block;
}
.hidden{
    display: none;;
}
</style>